import axios from 'axios'
import Vue from 'vue'
import Store from '@/store';
import Router from '@/router';
import {
	MessageBox,
	Message,
	Loading
} from 'element-ui';
import {
	userLogout
} from '@/http/api/user'

//创建axios
const service = axios.create({
	baseURL: process.env.NODE_ENV === "development" ? '/api' : process.env.VUE_APP_BASE_URL,
	// baseURL: process.env.VUE_APP_BASE_URL,
	timeout: 60000,
	withCredentials: true
})

var messageBoxCount = 0,
	loadingCount = 0, //打开 laoding  的个数
	loading;
var tokenPromise = null;
var notGetToken = ['https://user.tsgyun.com/user/get-login-status', '/login/logout']
var notMessageByCode = ['/api/get_search_result']  // code 不报错

// loading开始 方法
function startLoading() {
	loadingCount++;
	loading = Loading.service({
		lock: true,
		text: '拼命加载中...',
		spinner: 'el-icon-loading', // 自定义图标
		background: 'rgba(0, 0, 0, 0)',
		customClass: 'loadingClass'
	})
}

// loading结束 方法
function loadingClose() {
	loadingCount--;
	loading.close()
}

function logout() {
	userLogout().then((res) => {}).catch((error) => {});
}
localStorage.removeItem('token')
async function getToken(refresh = false) {
	if (tokenPromise == null || refresh) {
		tokenPromise = new Promise((resolve, reject) => {
			service.get('https://user.tsgyun.com/user/get-login-status', {
				headers: {
					Token: sessionStorage.getItem('token')
				}
			}).then(res => {
				if (res.data.token) {
					sessionStorage.setItem('token', res.data.token)
					resolve(res.data.token)
				} else {
					sessionStorage.removeItem('token')
					logout()
				}
			}).catch((err) => {
				logout()
			})
		})
	}
	return tokenPromise
}

// 请求拦截器
service.interceptors.request.use(async (config) => {
	config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=utf-8'

	if (notGetToken.indexOf(config.url) == -1) {
		var token = await getToken()
		config.headers.Token = token;
	}
	if (config.requestLoading) {
		startLoading();
	}
	return config
}, error => {
	Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use((res) => {
	// console.log('响应拦截器：', res)
	if (res.config.requestLoading) {
		loadingClose();
	}
	if (res.config.notHasCode) { // 接口不返回 code  
		return res.data
	}

	// 未登录
	if (res.data.code == 1 || res.data.code == 4) {
		if (messageBoxCount == 0) {
			messageBoxCount++
			sessionStorage.removeItem('token')
			Store.commit('setUserInfo', null)
			MessageBox('您未进行登录或登录信息已过期, 去登录?', '提示', {
				type: 'warning'
			}).then(() => {
				messageBoxCount--
				var sid = process.env.VUE_APP_SID
				var url = `https://user.tsgyun.com/user/ssologin?sid=${sid}&returnUrl=` +
					encodeURIComponent(window.location.href)
				// console.log("url:", url)
				window.open(url, '_self')
			}).catch(() => {
				messageBoxCount--
			});
		}
		return Promise.reject(res)
	}

	// 无权限
	if (res.data.code == 2) {
		Router.push('/noPermission')
		return Promise.reject(res)
	}
	if (res.data.code !== 0) {
		if (notMessageByCode.indexOf(res.config.url) == -1) Message.error(res.data.msg || '请求数据失败')
		return Promise.reject(res)
	}

	return res.data

}, (error) => {
	if (error.config.requestLoading) {
		loadingClose();
	}
	return Promise.reject(error)
})

export default service